export default "__VITE_ASSET__CW954Ora__"